import Text, { TextColor, TextSize } from '@/components/view/atoms/text/Text'

interface Props {
  /** 会員番号。会員IDが取れない受注（ゲスト購入・未連携）は null */
  customerId: string | null
  /** 訪問者ID（クッキー）。計測タグ経由の受注のみ持つ */
  visitorId: string | null
  size?: TextSize
}

/**
 * 受注の購入者を表示する。
 *
 * 会員番号があればそれを通常の字で出し、無ければ訪問者IDを**薄字**で出す。
 * 同じ列に2種類の値が並ぶため、見た目を分けないと訪問者IDを会員番号と読み違える。
 * どちらも無い受注（会員IDの連携が無いCSV取込など）はハイフン。
 */
const PurchaserText = ({ customerId, visitorId, size = 12 }: Props) => {
  if (customerId) {
    return (
      <Text size={size} nowrap>
        {customerId}
      </Text>
    )
  }
  if (visitorId) {
    return (
      <Text size={size} color={TextColor.TERTIARY} nowrap>
        {visitorId}
      </Text>
    )
  }
  return (
    <Text size={size} nowrap>
      -
    </Text>
  )
}

export default PurchaserText
